export const WS_CONFIG = {
    URL: "wss://api.brandsek.com/websocket",
    PROTOCOL: "echo-protocol",
    RECONNECT_DELAY: 500,
    MESSAGE_TIMEFRAME: {
        FROM: "2024-11-28T00:00:00.000Z",
        TILL: "2024-12-30T23:59:59.999Z"
    }
};
